import { createColumnHelper } from '@tanstack/react-table';
import cn from 'classnames';
import { useMemo } from 'react';
import { Banner } from '#components/atoms/banner/Banner.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import { Table } from '#components/patterns/table/Table.tsx';
import type { RouteFormData } from '../route-form-schema.ts';
import styles from './RoutableCIDRs.module.css';

type Props = {
  cidrs: RouteFormData['routableCIDRs'];
  onRemove: (index: number) => void;
  onEdit: (index: number) => void;
  children?: React.ReactNode;
};

const columnHelper = createColumnHelper<RouteFormData['routableCIDRs'][number]>();

export function RoutableCIDRs({ cidrs, children, onEdit, onRemove }: Props) {
  const columns = useMemo(
    () => [
      columnHelper.accessor('cidr', {
        header: 'CIDR',
        size: 160,
      }),
      columnHelper.accessor('install', {
        header: 'Install automatically',
        size: 160,
      }),
      columnHelper.display({
        id: 'routable-cidr-action-menu',
        header: '',
        size: 32,
        cell(info) {
          return (
            <div className="flex justify-end">
              <MeatballMenu>
                <MenuItem
                  onClick={() => {
                    const index = cidrs.findIndex((i) => i.cidr === info.row.original.cidr);
                    onEdit(index);
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    const index = cidrs.findIndex((i) => i.cidr === info.row.original.cidr);
                    onRemove(index);
                  }}
                >
                  Delete
                </MenuItem>
              </MeatballMenu>
            </div>
          );
        },
      }),
    ],
    [onEdit, onRemove, cidrs]
  );

  return (
    <div>
      {cidrs.length ?
        <Table className={cn('mb-16 border-b', styles.RoutableCIDRs)} data={cidrs} columns={columns} hideOverflowX />
      : <Banner className="mb-16">None defined</Banner>}
      {children}
    </div>
  );
}
